import styled from 'styled-components';
const UICardHero = styled.div.withConfig({
  displayName: "UICardHero",
  componentId: "sc-1r9bhb8-0"
})([".hs-private.hs-private.hs-private &{border-top-left-radius:inherit;border-top-right-radius:inherit;overflow:hidden;}"]);
UICardHero.displayName = 'UICardHero';
export default UICardHero;